import { FC } from 'react';
import { Form, FormItemProps } from 'antd';
import { useFormCommon } from '@/components/FormCommon';
import { isType } from '@/utils';

export interface BaseItemProps extends FormItemProps {
  depends?: boolean | Record<string, any>;
}

const isVisible = (depends: any, gfd: Func) => {
  let keys = Object.keys(depends);
  let result = true;
  let i = 0;
  while (i < keys.length) {
    let k = keys[i];
    if (!k) break;
    if (isType(depends[k], 'array')) {
      result = (depends[k] as any[]).some((v) => v === gfd(k));
    } else {
      result = gfd(k) === depends[k];
    }
    if (!result) break;
    i++;
  }
  return result;
};

const BaseItem: FC<BaseItemProps> = ({
  label = ' ',
  name,
  depends = true,
  className = '',
  children,
  ...rest
}) => {
  const parentForm = useFormCommon()!;
  if (!parentForm) return null;
  const { getFieldValue } = parentForm;
  /**
   * 如果值是undefined 说明没有该配置
   */
  if (name && isType(getFieldValue(name), 'undefined')) return null;
  /**
   * 联动处理
   */
  if (isType(depends, 'boolean') && !depends) return null;
  if (isType(depends, 'object') && !isVisible(depends, getFieldValue))
    return null;

  return (
    <div className={`backend-form-item ${className}`}>
      <Form.Item
        label={label}
        name={name}
        hidden={false}
        labelAlign='right'
        labelCol={{ span: 10 }}
        wrapperCol={{ span: 12, offset: 1 }}
        className='base-form-item'
        {...rest}
      >
        {children}
      </Form.Item>
    </div>
  );
};

export default BaseItem;
